/**
 * Created by User on 18/02/2016.
 */
import Observer from '../../utils/Observer';
import AdConsts from '../../AdConsts';
import Utils from '../../utils/Utils';
import AdElementBase from './AdElementBase';
import VastDocument from './VastDocument';

export default AdElement;

function AdElement(url) {
  AdElementBase.apply(this, arguments);
  this._vastDocument = null;
  var self = this;

  this.load = function() {
    self._vastDocument = new VastDocument();


    // self._url = 'https://ad.doubleclick.net/ddm/pfadx/N1933.1727852MEGOGO.NET/B11101255.149422012;sz=0x0;ord=%25random%25;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;dcmt=text/xml';


    self._vastDocument.getMedia(self._url, _onVastDocumentCallback);
  };

  this.track = function(eventName, params) {
    if (self._vastDocument && typeof self._vastDocument[eventName] === 'function') {
      //make array from params for calling function by 'apply'
      if (!Array.isArray(params)) {
        params = [ params ];
      }
      self._vastDocument[eventName].apply(self._vastDocument, params);
    }
  };


  Object.defineProperties(this, {
    'trackingData': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = null;
        if (self._vastDocument) {
          if (self._vastDocument.isLinear) {
            result = self._vastDocument.trackingData;
          } else {
            result = self._vastDocument.trackingDataNonLinear;
          }
        }
        return result;
      }
    },
    'vastData': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = null;
        if (self._vastDocument) {
          result = self._vastDocument.vastData;
        }
        return result;
      }
    },
    'linear': {
      enumerable: true,
      configurable: true,
      get: function () {
        return self._vastDocument ? self._vastDocument.isLinear : null;
      }
    },
    'vastDocument': {
      enumerable: true,
      configurable: true,
      get: function() {
        return self._vastDocument;
      }
    },
    'apiFramework': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = '';
        if (self._vastDocument && self._vastDocument.vastData && self._vastDocument.vastData.mediaFile
					&& self._vastDocument.vastData.mediaFile.length > 0 && self._vastDocument.vastData.mediaFile[0].apiFramework) {
          result = self._vastDocument.vastData.mediaFile[0].apiFramework;
        }
        return result;
      }
    }
  });

  var _onVastDocumentCallback = function(response) {
    if (response.isError === false) {
			
      //logic for MHP-164: do not show any ad in block after VPAID
      if (self.vastData) {
        var mediaFile = self.vastData.mediaFile;
        if (mediaFile.length > 0) {
          mediaFile = mediaFile[0];
          if (mediaFile.apiFramework && mediaFile.apiFramework.toUpperCase() == 'VPAID') {
            var player = Observer.getObserverInstance();
            if (player && player.config && player.config.vpaidAllow === false) {
              self.vastData[AdConsts.ALLOW_BLOCK] = [ "0" ];
            }
          }
        }
      }
			
      Observer.emit(AdConsts.ELEMENT_CREATING_SUCCESS, self);
    } else if (response.isError === true) {
      if (response.error && response.error.length > 0) {
        for (var i = 0, l = response.error.length; i < l; ++i) {
          if (Utils.isStringWithData(response.error[i])) {
            try {
              document.createElement('img').src = response.error[i];
            } catch (error) {}
          }
        }
      }
      Observer.emit(AdConsts.ELEMENT_CREATING_FAIL, self);
    } else if (AdConsts.GOOGLE_IN_VAST in response) {
      Observer.emit(AdConsts.GOOGLE_IN_VAST,
        {
          url: response[AdConsts.GOOGLE_IN_VAST],
          vastDocument: self._vastDocument
        }
      );
    }
  };

}
AdElement.prototype.constructor = AdElement;
//module.export = AdElement;















